import styled from 'styled-components'

import ListasAnteriores, {
  TListasAnteriores,
} from '@/app/2023/consejo/consejeros/types/listasAnteriores'
import { Lista } from '@/app/2023/consejo/types/listas'
import listas from '@/app/2023/consejo/types/listas'
import { colors, spaces } from '@/config/global-parameters'

import ProgressBarBase from '../../ParticipationSection/ParticipationTable/ProgressBar'

export interface IListVotesItem {
  className?: string
  circumscriptionVotes: number
  listVotes: number
  list: Lista | TListasAnteriores
}

const ListVotesItem = ({ circumscriptionVotes, className, list, listVotes }: IListVotesItem) => {
  const allLists = { ...listas, ...ListasAnteriores }
  const options = [
    {
      color: allLists[list].color,
      count: listVotes,
      key: 'listVotes',
    },
    {
      color: colors.colorGrey25,
      count: circumscriptionVotes - listVotes,
      key: 'circumscriptionVotes',
    },
  ]

  return (
    <Wrapper className={className}>
      <ElectionChart>
        <ProgressBar
          height="19px"
          options={options}
          textBlend
          total={circumscriptionVotes}
        />
      </ElectionChart>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: contents;
  > * {
    padding: 10px 0;
  }
  :hover {
    > * {
      background: ${colors.colorGrey10};
    }
  }
`

const ProgressBar = styled(ProgressBarBase)`
  & :after {
    margin: 1px 0;
  }
  width: 100%;
`

const ElectionChart = styled.div`
  display: flex;
  align-items: center;
  min-width: 32px;
  max-width: 32px;
  width: 100%;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    min-width: 24px;
    max-width: 24px;
  }
`

export default ListVotesItem
